import $http from './http'
import config from './config'

export default {
    name: 'side',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getFileContent(url){
        return $http.get(url,{failTips:false});
    },
    location(data) {
        return $http.post(this.getUrl(`/Common/Location`), data);
    },
    getValidImageUrl() {
        return `${this.getUrl("/Common/ValidCode")}?${Math.random()}`;
    },
}    


// WEBPACK FOOTER //
// ./src/apis/sideapi.js